import { useContext, useEffect, useRef, useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { AuthContext } from '../context/AuthContext';

export default function SsoComplete() {
  const { restoreSession } = useContext(AuthContext);
  const [failed, setFailed] = useState(false);
  const bootstrapStartedRef = useRef(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (bootstrapStartedRef.current) {
      return;
    }

    bootstrapStartedRef.current = true;

    void (async () => {
      if (await restoreSession()) {
        navigate('/home', { replace: true });

        return;
      }

      setFailed(true);
      toast.error('Não foi possível concluir o acesso. Tente novamente.');
    })().catch(() => {
      setFailed(true);
      toast.error('Não foi possível concluir o acesso. Tente novamente.');
    });
  }, [
    navigate,
    restoreSession,
  ]);

  if (failed) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'grid',
        placeItems: 'center',
      }}
    >
      Concluindo acesso seguro…
    </div>
  );
}
